/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Attachedcertificate1Inputs */

const en__field_attachedcertificate1 = /** @type {(inputs: _Field_Attachedcertificate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`attached Certificate`)
};

const de__field_attachedcertificate1 = /** @type {(inputs: _Field_Attachedcertificate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beigefügtes Zertifikat`)
};

/**
* | output |
* | --- |
* | "attached Certificate" |
*
* @param {_Field_Attachedcertificate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_attachedcertificate1 = /** @type {((inputs?: _Field_Attachedcertificate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Attachedcertificate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_attachedcertificate1(inputs)
	return de__field_attachedcertificate1(inputs)
});
export { _field_attachedcertificate1 as "_field_attachedCertificate" }